import React from 'react'
import { BaseTree } from '../components/DepartmentTree'
import SelectDepartment, { filterDepartment } from './SelectDepartment'

const DepartmentTreeComponent = (props) => {

  const { input, config, selectDepartment } = props

  const [ value, setValue ] = React.useState(null)

  const onChange = (item, e) => {
    if (config.multiple) {
      setValue(item.id)
      input.onChange(item)
    } else {
      setValue(item.id)
      input.onChange(item ? [item] : [])
    }
    
  }

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <BaseTree noCard={true} onChange={ onChange } value={value} {...config} selectDepartment={selectDepartment} filterDepartment={filterDepartment} />
    </div>
  )
}

const DepartmentTree = {
  title: '部门树',
  category: '业务选择器',
  icon: require('../icon/部门树.svg'),
  component: DepartmentTreeComponent,
  paramSchema: {
    type: 'object',
    fieldType: 'fieldset_card',
    properties: {
      config: {
        title: '配置项',
        type: 'object',
        fieldType: 'fieldset_card',
        properties: {
          multiple: {
            title: '多选',
            type: 'boolean'
          }
        }
      },
      selectDepartment: {
        title: '选择部门',
        type: 'array',
        items: {},
        field: {
          component: SelectDepartment
        }
      }
    }
  },
  fieldWidget: true,
  initParam: { autoHeight: true },
  initLayout: { width: 300, height: 600 }
}

export default DepartmentTree
